<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>档口日账单</div>
      <!-- <el-button class="icon-fresh" size="mini" icon="el-icon-refresh" @click="fetchData(true)">刷新</el-button> -->
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form :inline="true" :model="form" class="demo-form-inline">
                  <!-- <el-form-item label="输入搜索：">
                    <el-input v-model="form.supply_name" placeholder="商家" @keyup.native.enter="search"></el-input>
                  </el-form-item> -->
                  <el-form-item>
                    <el-select
                      v-model="form.pgid"
                      placeholder="选择代采组"
                      filterable
                      clearable
                      @change="onSelectChange"
                    >
                      <el-option
                        v-for="item in pGroup"
                        :key="item.pgid"
                        :label="item.pgname"
                        :value="item.pgid"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.supply_id"
                      placeholder="选择商家"
                      filterable
                      clearable
                    >
                      <el-option
                        v-for="item in supplyGroup"
                        :key="item.supply_id"
                        :label="item.supply_name"
                        :value="item.supply_id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-date-picker
                      v-model="form.date"
                      type="date"
                      placeholder="选择日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row
      v-if="
        filteredForm.supply_id && pGroup.length > 0 && supplyGroup.length > 0
      "
    >
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            height: 50px;
            line-height: 50px;
            padding: 0 25px;
            text-align: center;
          "
        >
          <span style="color: #ff3976">{{
            pGroup.find((element) => element.pgid === filteredForm.pgid).pgname
          }}</span>
          在
          <span style="color: #ff3976">{{
            (supplyGroup.find(
              (element) => element.supply_id === filteredForm.supply_id
            ) &&
              supplyGroup.find(
                (element) => element.supply_id === filteredForm.supply_id
              ).supply_name) ||
            ""
          }}</span
          >商家 {{ filteredForm.the_date }} 的对账单
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
            text-align: center;
          "
        >
          <div>账单开始</div>
        </div>
        <div v-if="resData.startDayData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            :data="resData.startDayData"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column prop="operate_type" label="日期" align="center">
            </el-table-column>
            <el-table-column prop="cg_owe_num" label="欠货件数" align="center">
            </el-table-column>
            <el-table-column
              prop="cg_owe_amount"
              label="欠货金额"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="rj_owe_num" label="退款件数" align="center">
            </el-table-column>
            <el-table-column
              prop="rj_owe_amount"
              label="退款金额"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="wait_ded_num"
              label="欠款件数"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="wait_ded_amount"
              label="欠款金额"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>账单明细</div>
          <!-- <el-button style="margin-left: auto;" type="success" size="mini" @click="output">导出</el-button> -->
        </div>
        <div v-if="resData.list" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-table
                  :data="props.row.item"
                  tooltip-effect="dark"
                  style="width: 100%"
                  border
                >
                  <el-table-column prop="" label="" align="center">
                  </el-table-column>
                  <el-table-column
                    prop="operate_type"
                    label="操作"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="cg_owe_num"
                    label="欠货件数"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="cg_owe_amount"
                    label="欠货金额"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="rj_owe_num"
                    label="退款件数"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="rj_owe_amount"
                    label="退款金额"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="wait_ded_num"
                    label="欠款件数"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="wait_ded_amount"
                    label="欠款金额"
                    align="center"
                  >
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column prop="operate_type" label="操作" align="center">
            </el-table-column>
            <el-table-column prop="cg_owe_num" label="欠货件数" align="center">
            </el-table-column>
            <el-table-column
              prop="cg_owe_amount"
              label="欠货金额"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="rj_owe_num" label="退款件数" align="center">
            </el-table-column>
            <el-table-column
              prop="rj_owe_amount"
              label="退款金额"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="wait_ded_num"
              label="欠款件数"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="wait_ded_amount"
              label="欠款金额"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>账单结束</div>
        </div>
        <div v-if="resData.endDayData" style="margin-bottom: 0">
          <el-alert
            v-if="resData.diffMark > 0"
            title="数据不对等"
            type="error"
            center
            show-icon
          >
          </el-alert>
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            :data="resData.endDayData"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column prop="operate_type" label="日期" align="center">
            </el-table-column>
            <el-table-column prop="cg_owe_num" label="欠货件数" align="center">
            </el-table-column>
            <el-table-column
              prop="cg_owe_amount"
              label="欠货金额"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="rj_owe_num" label="退款件数" align="center">
            </el-table-column>
            <el-table-column
              prop="rj_owe_amount"
              label="退款金额"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="wait_ded_num"
              label="欠款件数"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="wait_ded_amount"
              label="欠款金额"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: "",
      form: {
        date: new Date(),
      },
      loading: false,
      url: "/erp/SupplyDayBillReport/getSupplyDayReport",
      // curPage: 1,
      tableLoading: false,
      filterFold: false,
      pGroup: [],
      supplyGroup: [],
    };
  },
  computed: {
    filteredForm() {
      //用来请求接口的form参数
      for (let key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      this.form.the_date = this.formatDate(this.form.date);
      return this.form;
    },
  },
  methods: {
    formatDate(date) {
      var year = date.getFullYear();
      var month = date.getMonth();
      var day = date.getDate();
      var defaultDate = `${year}-${month + 1}-${day}`;
      return defaultDate;
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    search() {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post("/erp/PurchaseGroup/getPgList").then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.pGroup = res.data.data.list;
        }
      });
    },
    onSelectChange(v) {
      this.fetchSupplyGroup(v);
    },
    fetchSupplyGroup(pgid) {
      var params = {
        pgid: pgid,
      };
      this.$http.post("/erp/WcgOrder/getPgSupply", params).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.supplyGroup = res.data.data.list;
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/SupplyDailyPaper.vue